/* Aero3DLab V-PRi size guide only. No cart, product form, checkout, or global functions. */
(() => {
  'use strict';
  const points = [[150,'XS'],[153,'XS'],[155,'XS / S'],[158,'S'],[162,'S'],[165,'S'],[168,'S'],[170,'S / M'],[173,'S / M'],[175,'M'],[178,'M / L'],[180,'M / L'],[183,'L'],[185,'L'],[188,'L / XL'],[190,'XL'],[193,'XL'],[196,'XL']];
  function init() {
    const root = document.getElementById('vpri-size-guide');
    if (!root) return;
    const slider = root.querySelector('#vpri-height-range');
    const heightText = root.querySelector('#vpri-height-display');
    const sizeText = root.querySelector('#vpri-size-display');
    if (!slider || !heightText || !sizeText || slider.dataset.aeroVpriReady === '1') return;
    slider.dataset.aeroVpriReady = '1';
    const update = () => {
      const height = Number(slider.value);
      if (!Number.isFinite(height)) return;
      const closest = points.reduce((best, current) => Math.abs(current[0]-height) < Math.abs(best[0]-height) ? current : best);
      heightText.textContent = `${height} cm`;
      sizeText.replaceChildren(document.createTextNode(`${closest[1]} `));
      const caption = document.createElement('small');
      caption.textContent = 'サイズ候補（目安）';
      sizeText.appendChild(caption);
    };
    slider.addEventListener('input', update);
    slider.addEventListener('change', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
